import React from 'react';
import ErrorContent from './ErrorContent';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
  }

  handleReload = () => {
    window.location.reload();
  };

  handleCopyError = () => {
    const errorText = `${this.state.error && this.state.error.toString()}\n${
      this.state.errorInfo.componentStack
    }`;
    navigator.clipboard.writeText(errorText).catch((err) => {
      console.error('Failed to copy error:', err);
    });
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorContent
          title={this.props.title || 'Something went wrong'}
          error={
            this.state.errorInfo ? (
              <>
                <div
                  style={{
                    marginTop: 16,
                    marginBottom: 16,
                    display: 'flex',
                    gap: 8,
                  }}
                >
                  <button onClick={this.handleCopyError}>Copy Error</button>
                  <button onClick={this.handleReload}>Reload Page</button>
                </div>
                <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                  {this.state.error && this.state.error.toString()}
                  {'\n'}
                  {this.state.errorInfo.componentStack}
                </pre>
              </>
            ) : null
          }
        />
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
